import styled, { keyframes } from 'styled-components';

const blink = keyframes`
  0% {
    opacity: .2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: .2;
  }
`;

export const StyledEachCell = styled.div`
  font-size: 14px;
  color: #000;
  white-space: nowrap;

  .warmup-loader span{
    animation-name: ${blink};
    animation-duration: 1.4s;
    animation-iteration-count: infinite;
    animation-fill-mode: both;
    font-size: 14px;
    font-weight: 700;
    margin: 0px 1px;

    &:nth-child(2) {
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
`;

export const StyledCellWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;

export const StyledCellContainer = styled.div`
  height: 100%;
`;

export const StyledChartContainer = styled.div`
  flex: 1;
  height: 100%;
  position: relative;
`;

export const StyledSkeleton = styled.div`
  padding: 10px;
  width: 100%;

  .ant-skeleton-title {
    display: none;
  }

  .ant-skeleton-paragraph {
    margin-top: 15px;
    li {
      height: 10px;
    }
  }
`;
